import { startOfDay, sub } from 'date-fns';
import { FilterType } from 'portal-commons';

import {
  getBrandNameAutocompleteOptions,
  getCspNameAutocompleteOptions,
} from '@/apis/services';

const Today = startOfDay(new Date());
const DateRangePresets = [
  {
    label: 'Today',
    start: Today,
    end: Today,
  },
  {
    label: 'Last 7 Days',
    start: sub(Today, { days: 7 }),
    end: Today,
  },
  {
    label: 'Last 1 Month',
    start: sub(Today, { months: 1 }),
    end: Today,
  },
  {
    label: 'Last 6 Months',
    start: sub(Today, { months: 6 }),
    end: Today,
  },
];

const StatusOptions = [
  {
    label: 'Active',
    value: 'ACTIVE',
  },
  {
    label: 'Deactivated',
    value: 'EXPIRED',
  },
];

const SharingStatusOptions = [
  {
    label: 'Accepted',
    value: 'ACCEPTED',
  },
  {
    label: 'Pending',
    value: 'PENDING',
  },
];

export const FilterConfigs = {
  campaignUid: {
    type: FilterType.Text,
    label: 'Campaign ID',
    placeholder: 'Type Campaign ID',
    width: 192,
  },
  // displayName: {
  //   type: FilterType.Text,
  //   label: 'Display Name',
  //   placeholder: 'Type display name',
  //   suggestions: [],
  //   width: 224,
  // },
  brandUid: {
    type: FilterType.Text,
    label: 'Brand ID',
    placeholder: 'Type Brand ID',
    width: 192,
  },
  brandName: {
    type: FilterType.Text,
    label: 'Brand DBA Name',
    placeholder: 'Type Brand DBA name',
    suggestions: [],
    width: 224,
  },
  usecase: {
    type: FilterType.Dropdown,
    label: 'Use Case',
    options: [],
    width: 192,
  },
  billingCategory: {
    type: FilterType.Dropdown,
    label: 'Billing Category',
    options: [],
    width: 210,
  },
  cspName: {
    type: FilterType.Text,
    label: 'CSP DBA Name',
    placeholder: 'Type CSP DBA Name',
    suggestions: [],
    width: 224,
  },
  downstreamCnpUid: {
    type: FilterType.Dropdown,
    label: 'Downstream CNP',
    options: [],
    multiple: true,
    width: 250,
  },
  sharedOnDate: {
    type: FilterType.DateRange,
    label: 'Shared On',
    delayUpdate: false,
    dateRangePresets: DateRangePresets,
    width: 250,
  },
  status: {
    type: FilterType.Dropdown,
    label: 'TCR Status',
    options: StatusOptions,
    width: 192,
  },
  sharingStatus: {
    type: FilterType.Dropdown,
    label: 'Acceptance Status',
    options: SharingStatusOptions,
    multiple: true,
    width: 192,
  },
};

export const FilterLoaders = {
  suggestion: {
    brandName: {
      minLength: 2,
      load: (value: string) => getBrandNameAutocompleteOptions(value),
    },
    cspName: {
      minLength: 2,
      load: (value: string) => getCspNameAutocompleteOptions(value),
    },
    // todo: add campaign display name suggestion
  },
};

export const TableHeaders = [
  { id: 'uid', label: 'Campaign ID', sortable: true },
  // { id: 'displayName', label: 'Display Name', sortable: false },
  { id: 'brandUid', label: 'Brand ID', sortable: true },
  { id: 'brandName', label: 'Brand DBA Name', sortable: false },
  { id: 'usecase', label: 'Use Case', sortable: true },
  { id: 'billingCategory', label: 'Billing Category', sortable: false },
  { id: 'cspName', label: 'CSP DBA Name', sortable: false },
  { id: 'downstreamCnpName', label: 'Downstream CNP', sortable: false },
  { id: 'sharedOnDate', label: 'Shared On', sortable: true },
  { id: 'status', label: 'TCR Status', sortable: false },
  {
    id: 'sharingStatus',
    label: 'Acceptance Status',
    sortable: false,
  },
];
